export enum SurveyAudienceEnum {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  ALL = "ALL",
  CAC = "CAC",
  COLLAB = "COLLAB",
  // eslint-disable-next-line @typescript-eslint/naming-convention
  BROADCAST_LIST = "BROADCAST_LIST"
}

export const SURVEY_AUDIENCES = [
  {
    value: SurveyAudienceEnum.ALL,
    label: "add_survey.audience.labels.ALL"
  },
  {
    value: SurveyAudienceEnum.CAC,
    label: "add_survey.audience.labels.CAC"
  },
  {
    value: SurveyAudienceEnum.COLLAB,
    label: "add_survey.audience.labels.COLLAB"
  },
  {
    value: SurveyAudienceEnum.BROADCAST_LIST,
    label: "add_survey.audience.labels.BROADCAST_LIST"
  }
] as { value: string; label: string }[];
